var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRawBracket = function SvgRawBracket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 159,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M49.964 159q-11.196 0-18.214-2.715-6.852-2.545-10.027-7.806-3.007-5.09-3.007-12.896V104.19q0-9.502-4.345-13.575Q10.194 86.542 0 86.542V72.627q10.194 0 14.37-4.072 4.346-4.072 4.346-13.575V23.417q0-7.806 3.007-12.896Q24.9 5.26 31.75 2.715 38.768 0 49.964 0v13.236q-8.523 0-12.199 2.545-3.51 2.546-3.509 7.976v33.768q0 8.994-4.679 14.424-4.512 5.43-13.535 7.636 9.024 2.036 13.535 7.466 4.68 5.43 4.68 14.424v33.768q0 5.43 3.508 7.976 3.676 2.545 12.199 2.545z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M72 47.407c0 6.685-5.337 12.105-11.92 12.105s-11.92-5.42-11.92-12.105 5.337-12.104 11.92-12.104S72 40.722 72 47.407"
  })));
};
export default SvgRawBracket;